
import { computed, defineComponent, toRefs } from "vue";
import RankingProgress from "./ranking-progress.vue";
import { PosLeaderboardCardDetail } from "@/domain/entities/PosLeaderboard";
import { formatPriceWithoutCurrency } from "@/app/infrastructures/misc/Utils";
import { AccountController } from '@/app/ui/controllers/AccountController';
import formatPriceRP from '@/app/infrastructures/misc/common-library/v2/FormatPriceRP';

export default defineComponent({
  name: "TabRevenue",
  components: { RankingProgress },
  props: {
    isNewPos: Boolean,
    isRightPodium: Boolean,
    data: {
      type: PosLeaderboardCardDetail,
      default: () => new PosLeaderboardCardDetail()
    }
  },
  setup(props) {
    const refProps = toRefs(props);
    const { data, isRightPodium } = refProps;

    /* ---------- Flags ---------- */
    const isTopRank = computed(() => data.value.rank && data.value.rank <= 5);

    /* ---------- Container ---------- */
    const containerClass = computed(() => ({
      "pb-1": isRightPodium.value,
      "pb-3": !isRightPodium.value
    }));

    const containerStyle = computed(() => ({
      height: isRightPodium.value ? "81px" : "96px",
      backdropFilter: "blur(20px)",
      boxShadow: "50px 60px 100px 0px #0000000D"
    }));

    /* ---------- Rank Badge ---------- */
    const rankTranslateClass = computed(() =>
      isRightPodium.value ? "-translate-y-16" : "-translate-y-17"
    );

    const rankIcon = computed(() =>
      require(`../assets/ranking-${data.value.rank}.svg`)
    );

    const rankIconStyle = computed(() => ({
      height: isRightPodium.value ? "81px" : "96px"
    }));

    const rankCircleSize = computed(() =>
      isRightPodium.value ? "90px" : "110px"
    );

    const rankCircleStyle = computed(() => ({
      width: rankCircleSize.value,
      height: rankCircleSize.value,
      boxShadow: "0px 8px 15px 0px #1A142126",
      backgroundColor: "#C5C5C5"
    }));

    const rankFontSize = computed(() => {
      const len = String(data.value.rank).length;
      if (len === 1) return "4rem";
      if (len === 2) return "3rem";
      if (len === 3) return "2.25rem";
      return isRightPodium.value ? "1.125rem" : "1.5rem";
    });

    /* ---------- Rank Delta ---------- */
    const rankDeltaTranslateClass = computed(() =>
      isRightPodium.value ? "-translate-y-17" : "-translate-y-19"
    );

    const rankDeltaMarginClass = computed(() =>
      String(data.value.rankDelta).length < 3 ? "ml-22" : "ml-26"
    );

    /* ---------- Text ---------- */
    const titleMarginClass = computed(() =>
      isRightPodium.value ? "mb-1" : "mb-1.5"
    );

    const rewardLabelClass = computed(() =>
      isRightPodium.value ? "text-10px" : "text-xs"
    );

    const rewardValueClass = computed(() =>
      isRightPodium.value ? "text-base" : "text-lg"
    );

    const accountCurrency = computed(() => {
      return (
        (AccountController.accountData?.accountCurrency as "IDR" | "MYR") ??
        "IDR"
      );
    });

    return {
      ...refProps,

      isTopRank,
      rankIcon,
      rankIconStyle,
      rankFontSize,
      rankCircleStyle,

      containerClass,
      containerStyle,
      rankTranslateClass,
      rankDeltaTranslateClass,
      rankDeltaMarginClass,

      titleMarginClass,
      rewardLabelClass,
      rewardValueClass,

      formatPriceRP,
      formatNumber: formatPriceWithoutCurrency,
      accountCurrency
    };
  }
});
